var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-block"},_vm._l((_vm.days),function(day){return _c('p',{key:day,staticClass:"has-text-theme-back",class:[
      _vm.selected_weekdays.includes(day)
        ? 'is_selected is-semiBold-14-600-17'
        : 'is-medium-14-500-17 has-opacity-6'
    ],on:{"click":function($event){return _vm.select_days(day)}}},[_vm._v(" "+_vm._s(_vm.localization(`app-${day.toLowerCase()}`, day))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }